module.exports = __webpack_public_path__ + "static/user-test-1-b18b284dffb5a9951e814d1a824135e2.jpg";